import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1150 (donations workspace).
// Contract: specs/_product/field-primitive-registry.md §1 ('amount').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function AmountField(props: FieldPrimitiveProps<number>) {
  return <FieldStub {...props} fieldType="amount" inputType="number" />;
}
